import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const getCategories = () => {

    const categoriesData = [];
    for (let i = 0; i <= new Date().getHours(); i++) {
        if (i < 10) {
            categoriesData.push(`0${i}:00`);
        } else {
            categoriesData.push(`${i}:00`);
        }
    }
    return categoriesData;
};

const getVehicles = (type, dataSet, deviceDirection) => {

    const vehiclesData = new Array(new Date().getHours()).fill(0);

    for (let i = 0; i < dataSet.length; i++) {
        if (
            deviceDirection === "In" &&
            dataSet[i].deviceId === "600a0c2a69e88a8e"
        ) {
            if (type === "p") {
                
                vehiclesData[parseInt(dataSet[i].hour.split(":")[0])] = dataSet[i].vehiclesCount;
            } else if (type === "t") {
                vehiclesData[parseInt(dataSet[i].hour.split(":")[0])] = dataSet[i].otherCount;
            }
        } else if (
            deviceDirection === "Out" &&
            dataSet[i].deviceId === "600a0c2a69e88a8c"
        ) {
            if (type === "p") {
                vehiclesData[parseInt(dataSet[i].hour.split(":")[0])] = dataSet[i].vehiclesCount;
            } else if (type === "t") {
                vehiclesData[parseInt(dataSet[i].hour.split(":")[0])] = dataSet[i].otherCount;
            }
        }
    }

    return vehiclesData;
};

const StackedChart = ({ data, direction }) => {

    console.log(window.innerWidth/74*-1);

    const chartState = {
        series: [
            {
                name: "Private",
                data: getVehicles("p", data, direction),
            },
            {
                name: "Truck",
                data: getVehicles("t", data, direction),
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 350,
                stacked: true,
                toolbar: {
                    show: true,
                },
                zoom: {
                    enabled: true,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: "bottom",
                            offsetX: -10,
                            offsetY: 0,
                        },
                    },
                },
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 10,
                    borderRadiusApplication: "end", // 'around', 'end'
                    borderRadiusWhenStacked: "last", // 'all', 'last'
                    dataLabels: {
                        total: {
                            offsetX:window.location.hostname === 'localhost'? 0:window.innerWidth/74*-1,
                            enabled: true,
                            style: {
                                fontSize: "13px",
                                fontWeight: 900,
                            },
                        },
                    },
                },
            },
            xaxis: {
                type: 'category',
                categories: getCategories(),
            },
            legend: {
                position: "right",
                offsetY: 40,
            },
            fill: {
                opacity: 1,
            },
            colors: ["#008ffb", "#FFBF00"],
            title: {
                text: `Road90-${direction}`,
                align: 'center',
                margin: 10,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                  fontSize:  '14px',
                  fontWeight:  'bold',
                  fontFamily:  undefined,
                  color:  '#263238'
                },
            }
        },
    };

    return (
        <div>
            <div id="chart">
                <ReactApexChart
                    options={chartState.options}
                    series={chartState.series}
                    type="bar"
                    height={175}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default StackedChart;
